import React from 'react';
import { signatureData } from '../data/mockData';
import { CloudRain, Sparkles, DollarSign, Droplets, Lightbulb } from 'lucide-react';

const Signature = () => {
  const { statement, subtext } = signatureData;
  
  return (
    <section className="py-14 md:py-20 relative overflow-hidden bg-gradient-to-br from-teal-50 via-cyan-50/50 to-emerald-50">
      {/* Animated rain with dollar signs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Rain drops - teal/blue */}
        {[...Array(30)].map((_, i) => (
          <div
            key={`rain-${i}`}
            className="absolute w-0.5 h-8 md:h-10 bg-gradient-to-b from-teal-400/50 to-transparent animate-rain-drop"
            style={{
              left: `${(i * 3.3) % 100}%`,
              top: `-40px`,
              animationDelay: `${(i * 0.12) % 3}s`,
              animationDuration: `${0.9 + (i % 4) * 0.25}s`
            }}
          />
        ))}
        
        {/* Dollar sign rain - grey transparent */}
        {[...Array(12)].map((_, i) => (
          <div
            key={`dollar-${i}`}
            className="absolute animate-rain-drop-slow"
            style={{
              left: `${6 + i * 8}%`,
              top: `-24px`,
              animationDelay: `${i * 0.35}s`,
            }}
          >
            <DollarSign className="w-4 h-4 md:w-5 md:h-5 text-stone-400/25" />
          </div>
        ))}
        
        {/* Clouds */}
        <div className="absolute top-6 left-1/4 w-32 h-16 md:w-44 md:h-22 bg-white/60 rounded-full blur-2xl animate-cloud-drift" />
        <div className="absolute bottom-12 right-1/3 w-40 h-20 md:w-52 md:h-26 bg-teal-100/40 rounded-full blur-2xl animate-float" style={{ animationDelay: '1s' }} />
      </div>
      
      <div className="container mx-auto px-4 text-center relative z-10">
        {/* Icons cluster */}
        <div className="flex justify-center items-center gap-3 mb-5 md:mb-6">
          <Lightbulb className="w-6 h-6 md:w-8 md:h-8 text-amber-400 animate-pulse" />
          <div className="relative">
            <CloudRain className="w-12 h-12 md:w-16 md:h-16 text-teal-500 animate-bounce-slow" />
            <Sparkles className="absolute -top-1 -right-1 w-4 h-4 md:w-5 md:h-5 text-emerald-400 animate-pulse" />
            <DollarSign className="absolute -bottom-0.5 -left-2 w-4 h-4 md:w-5 md:h-5 text-stone-400/50" />
          </div>
          <Droplets className="w-5 h-5 md:w-7 md:h-7 text-cyan-400/70 animate-pulse" style={{ animationDelay: '0.5s' }} />
        </div>
        
        {/* Main statement */}
        <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-stone-800 mb-5 leading-tight">
          <span className="md:hidden">
            I make it{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-500 via-cyan-500 to-emerald-500">rain</span>
            <br />
            in the brainstorm.
          </span>
          <span className="hidden md:inline">
            I make it{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-500 via-cyan-500 to-emerald-500">rain</span>
            {' '}in the brainstorm.
          </span>
        </h2>
        
        {/* Subtext - bigger and more symmetric */}
        <p className="text-lg md:text-xl lg:text-2xl text-stone-600 max-w-xl mx-auto font-medium tracking-wide">
          Creative phygital strategy that
          <br />
          turns ideas into value.
        </p>
      </div>
    </section>
  );
};

export default Signature;
